module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/~/core-js/library/modules/_add-to-unscopables.js
// module id = 50
// module chunks = 0